import React from "react";
import { Text, Icon, Flex, Button } from "@chakra-ui/react";
import {
  primary,
  secondary,
  textSecondary,
  backgroundLight,
  newBorder,
  white,
  textPrimary,
} from "./../../../../../utils/colors";

import CardIcon from "./../../../../../components/icon/CardIcon";
import { TbCloudDown } from "react-icons/tb";
import StatusButtonNewLite from "../../../../../components/buttons/StatusButtonNewLite";
import dayjs from "dayjs";

export const columns = (translate, isMobile) => {
  const allColumns = [
    {
      Header: () => (
        <Flex h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("tenant.columnInvoiceDate")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "invoiceDate",
      width: 150,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { invoiceDate } = row.original;

        return (
          <Text
            maxWidth="80px"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="sm"
            fontWeight="500"
            color={textSecondary}
          >
            {dayjs(invoiceDate).format("YYYY-MM-DD")}
          </Text>
        );
      },
    },
    {
      Header: () => (
        <Flex h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("tenant.columnInvoiceNumber")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "invoiceId",
      width: 180,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { invoiceNumber } = row.original;

        return (
          <Flex>
            <Text
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
            >
              {invoiceNumber}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: () => (
        <Flex h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("tenant.columnInvoicePrice")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "price",
      width: 100,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { price } = row.original;

        return (
          <Flex>
            <Text
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
            >
              $ {price}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: () => (
        <Flex h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("tenant.columnInvoiceModule")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "module",
      width: 160,
      disableSortBy: true,
      Cell: ({ row }) => {
        let { productName } = row.original;

        let name = "";
        let isYearly = false;

        if (
          productName === "1 × Treatment Plans Module (at €1,239.84 / year)"
        ) {
          name = translate("module.treatmentPlans");
          isYearly = true;
        } else if (
          (productName =
            "1 × Premium Dentacasa Treatment Plans Subscription (at €128.00 / month)")
        ) {
          name = translate("module.treatmentPlans");
          isYearly = false;
        } else if (productName === "1 × Courses Module (at €128.00 / month)") {
          name = translate("module.courses");
          isYearly = false;
        } else {
          name = "-";
        }

        console.log("PRODUCT NAME", productName, isYearly);

        return (
          <Flex direction="column" textAlign="left">
            <Text
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="sm"
              color={textPrimary}
              fontWeight="500"
            >
              {name}
            </Text>
            <Text
              fontSize="0.8rem"
              fontWeight="500"
              color={textSecondary}
              m="3px 0 0"
            >
              {!isYearly
                ? translate("module.monthlyPlan")
                : translate("module.yearlyPlan")}
            </Text>
          </Flex>
        );
      },
    },
    // {
    //   Header: () => (
    //     <Flex h="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text mr={2}>{translate("tenant.columnInvoicePaymentMethod")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "paymentMethod",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { paymentMethodBrand, paymentMethodLast4 } = row.original;

    //     return (
    //       <Flex>
    //         {paymentMethodBrand !== "-" && (
    //           <CardIcon
    //             size="1.5rem"
    //             color={secondary}
    //             brand={paymentMethodBrand}
    //           />
    //         )}

    //         {paymentMethodBrand !== "-" ? (
    //           <Text
    //             overflow="hidden"
    //             whiteSpace="nowrap"
    //             fontSize="md"
    //             color={textSecondary}
    //             fontWeight="500"
    //             ml={2}
    //           >
    //             **** **** **** {paymentMethodLast4}
    //           </Text>
    //         ) : (
    //           <Text
    //             overflow="hidden"
    //             whiteSpace="nowrap"
    //             fontSize="xs"
    //             color={textSecondary}
    //             fontWeight="500"
    //             ml={2}
    //           >
    //             -
    //           </Text>
    //         )}
    //       </Flex>
    //     );
    //   },
    // },
    // {
    //   Header: () => (
    //     <Flex h="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text mr={2}>{translate("tenant.columnInvoicePdf")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "pdf",
    //   width: 130,
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { pdfLink } = row.original;

    //     return (
    //       <Flex>
    //         <Button
    //           variant="outline"
    //           bg={backgroundLight}
    //           border={`1px solid ${newBorder}`}
    //           color={textSecondary}
    //           borderRadius="1rem"
    //           size="md"
    //           fontSize="13px"
    //           onClick={() => window.open(pdfLink, "_blank")}
    //           _hover={{ bg: white, color: primary }}
    //           role="group"
    //         >
    //           <Icon
    //             as={TbCloudDown}
    //             color={textSecondary}
    //             mr={2}
    //             fontSize="1rem"
    //             _groupHover={{ color: primary }}
    //           />
    //           {translate("button.download")}
    //         </Button>
    //       </Flex>
    //     );
    //   },
    // },
    {
      Header: () => (
        <Flex h="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("tenant.columnInvoiceStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { pdfLink, status } = row.original;

        return (
          <Flex align="center" justify="flex-end" w="100%" gap="0.5rem">
            <Button
              variant="outline"
              bg={backgroundLight}
              border={`1px solid ${newBorder}`}
              color={textSecondary}
              borderRadius="1rem"
              size="md"
              fontSize="0.875rem"
              p="1rem"
              fontWeight="500"
              onClick={() => window.open(pdfLink, "_blank")}
              _hover={{ bg: white, color: primary }}
              role="group"
            >
              <Icon
                as={TbCloudDown}
                color={textSecondary}
                mr={2}
                fontSize="1rem"
                _groupHover={{ color: primary }}
              />
              {translate("button.download")}
            </Button>
            <StatusButtonNewLite
              // isUnclickable
              currentStatus={status}
              size="md"
              p="0 2rem"
              // onUpdateStatus={handleUpdateStatus}
              options="invoice"
            />
          </Flex>
        );
      },
    },
  ];

  // If on a mobile device, filter out the first column
  if (isMobile) {
    return allColumns.filter((_, index) => index !== 0);
  }
  return allColumns;
};
